import { TeeLoader } from '@/components/ui/tee-loader';

export interface IntakeLoadingStepProps {
  text: string;
}

/** Shared loading step for both the diagnostic run and the escalation call (D-13). */
export function IntakeLoadingStep({ text }: IntakeLoadingStepProps) {
  return (
    <div className="flex flex-col items-center justify-center py-8">
      <TeeLoader size="md" text={text} />
    </div>
  );
}

export default IntakeLoadingStep;
